import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Answer/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Answer/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Answer/Issue3";
import Issue4 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Answer/Issue4";
import Issue5 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Answer/Issue5";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson15AnswerProps = {
  materialCode: string;
  lessonNo: number;
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson15Answer = (props: Lesson15AnswerProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(1)}
        />
      </div>
      <div className={styles.section}>
        <Issue2
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(2)}
        />
      </div>
      <div className={styles.section}>
        <Issue3
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(3)}
        />
      </div>
      <div className={styles.section}>
        <Issue4
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(4)}
        />
      </div>
      <div className={styles.section}>
        <Issue5
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(5)}
        />
      </div>
    </>
  );
};
export default Lesson15Answer;
